// Replaces <br> tags with an explicit-height spacer div so margin collapse
// cannot produce zero gap. Named component so table renderers can filter it
// the same way they filter native <br> elements.
export const CustomBrRenderer = () => (
  <div className="str-chat-line-break h-4" />
);
